<template>
  <div class="the-panel">
    <the-logo></the-logo>
    <div class="the-panel__welcome">
      {{ $t("common.welcome") }}
      <el-select v-if="loginCandidateServices.length > 1"  size="mini" value-key="key" v-model="formModel.service">
        <template v-for="srv in loginCandidateServices" >
          <el-option :value="srv" :key="srv.key" :label="$t(`product.${ srv.key }`)">
          </el-option>
        </template>
      </el-select>
    </div>
    <div class="the-panel__inputs">
      <profet-ai-input class="the-panel__username" :label="viewModel.warn.username !== ''
          ? viewModel.warn.username
          : $t('common.username')
        " v-model="formModel.username" :imgSrc="images.user" :isWarning="viewModel.warn.username !== ''"
        focus></profet-ai-input>

      <profet-ai-input class="the-panel__password" :label="viewModel.warn.password !== ''
          ? viewModel.warn.password
          : $t('common.password')
        " :type="viewModel.showPassword ? 'text' : 'password'" v-model="formModel.password" :imgSrc="passwordIcon"
        :isWarning="viewModel.warn.password !== ''" :enableActionOnIcon="true" @actionOnIcon="toggleVisibility()"
        @enter="handleLoginBtnClick"></profet-ai-input>
    </div>

    <div class="the-panel__submit">
      <button v-show="!loading" class="btn" @click="handleLoginBtnClick">
        {{ $t("common.login") }}
      </button>
    </div>

    <div v-show="commonAlert !== ''" class="the-panel__alert">
      <p>{{ commonAlert }}</p>
      <p v-if="additionMsg && additionMsg != ''" class="the-panel__alert-addtional">{{ additionMsg }}</p>
    </div>
  </div>
</template>
<script>
import TheLogo from "./TheLogo";
import IconUserImg from "img/user.png";
import IconKeyImg from "img/password.png";
import IconVisibility from "img/visibility.svg";
import IconVisibilityOff from "img/visibility_off.svg";
import ProfetAiInput from "./input/ProfetAiInput";

export default {
  props: {
    commonAlert: String,
    loading: Boolean,
    additionMsg: String,
  }, // End of props
  components: {
    TheLogo,
    ProfetAiInput,
  }, // End of components
  data() {
    return {
      viewModel: {
        showPassword: false,
        warn: {
          username: "",
          password: "",
        }, // warn
      }, // End of viewModel
      formModel: {
        username: "",
        password: "",
        service: "",
      }, // formModel
      images: {
        user: IconUserImg,
        key: IconKeyImg,
        visibility: IconVisibility,
        visibilityOff: IconVisibilityOff,
      }, // imgaes
    };
  }, // End of data
  computed: {
    loginCandidateServices() {
      return Object.entries(window.config.product).reduce((acc, [key, value]) => {  
        if ( !!value ) {
          acc.push({
            key,
            uri: value
          })
        }
        return acc
      }, [])
    },
    passwordIcon() {
      if (this.formModel.password != "" && !this.viewModel.showPassword) {
        return this.images.visibility
      }
      if (this.formModel.password != "" && this.viewModel.showPassword) {
        return this.images.visibilityOff
      }
      return this.images.key
    },
  },
  methods: {
    handleLoginBtnClick() {
      if (this.formModel.username === "") {
        this.viewModel.warn.username = this.$t("validate.isRequired").format(
          this.$t("common.username")
        );
        return;
      } // if
      else {
        this.viewModel.warn.username = "";
      } // else

      if (this.formModel.password === "") {
        this.viewModel.warn.password = this.$t("validate.isRequired").format(
          this.$t("common.password")
        );
        return;
      } // if
      else {
        this.viewModel.warn.password = "";
      } // else

      this.$emit("loginEvent", this.formModel);
    }, // handleLoginBtnClick()
    toggleVisibility() {
      this.viewModel.showPassword = !this.viewModel.showPassword
    }, //toggleVisibility
  }, // End of methods
  created() {
    this.formModel.service = this.loginCandidateServices[0]
  }
}; // End of export
</script>
<style lang="scss" scoped>
@import "@/assets/scss/global.scss";

.the-panel {
  background: #edf3fc;
  flex-basis: 40%;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px;
  padding-bottom:55px;
  border-radius: 0px 0px 10px 10px;

  @include respond-to(pc) {
    flex-basis: 35%;
    padding-right: 32px;
    border-radius: 0px 10px 10px 0px;
  }
}

.the-panel__welcome {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #838383;
  font-size: 1.5rem;
  font-weight: 400;
  margin: 20px 0px 5px 0px;

  .el-select{
    width: 225px;
  }
}

.the-panel__inputs {
  display: flex;
  flex-direction: column;
}

// the-panel__inputs

.the-panel__username {
  font-size: 1rem;
  font-weight: 500;
  color: #bcbcbc;
}

// the-panel__username

.the-panel__password {
  font-size: 1rem;
  font-weight: 500;
  color: #bcbcbc;
}

// the-panel__username

.the-panel__alert {
  align-self: center;
  width: 100%;
  border: solid 1px #303030;
  box-sizing: border-box;
  text-align: center;
  color: #fc748a;
  font-size: 1.25rem;
  border: 0px;
  border-radius: 5px;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.1);
  padding: 15px;
  margin-top: 15px;
  background: #fff;
  border: 1px solid #fff;
  word-break: break-all;

  &-addtional {
    padding-top: 10px;
    font-size: 1rem;
  }

  
  @include respond-to(pc) {
    padding:10px
  }
}

.the-panel__submit {
  box-sizing: border-box;
  padding: 0px 20px;
  width: 100%;
  margin-top: 10px;

  .btn {
    color: #fff;
    width: 100%;
    background: #4264ec;
    display: block;
    cursor: pointer;
    border: 0px solid;
    outline: 0px;
    padding: 13px;
    font-size: 1rem;
    border-radius: 5px;

    &:hover,
    &:focus {
      background: #1e43d4;
    }
  }
}
</style>
